
import { PropType } from "vue";
import { prop, Vue, Options } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";
import SpecialDateRow from "./SpecialDateRow.vue";
import PickScheduleModal from "./PickScheduleModal.vue";
import { SpecialDateSchedule, RegularTimeSlot } from "./schedule-types";

class SpecialScheduleSectionProps {
  enabled = prop<boolean>({ default: false, type: Boolean });
  dates = prop<SpecialDateSchedule[]>({
    default: () => [],
    type: Array as PropType<SpecialDateSchedule[]>
  });
  loading = prop<boolean>({ default: false, type: Boolean });
  slotStartHour = prop<number>({ default: 8, type: Number });
  slotEndHour = prop<number>({ default: 23, type: Number });
  slotIntervalMinutes = prop<number>({ default: 60, type: Number });
  isDarkMode = prop<boolean>({ default: false, type: Boolean });
}

@Options({
  components: {
    OverlayPanel,
    SpecialDateRow,
    PickScheduleModal
  }
})
export default class SpecialScheduleSection extends Vue.with(
  SpecialScheduleSectionProps
) {
  modalOpen = false;
  isActiveTooltip = false;

  get tooltipTitle(): string {
    return (
      this.$t("pickup.scheduleConfig.special.tooltipTitle") || "Jadwal Khusus"
    );
  }

  get tooltipDescription(): string {
    return (
      this.$t("pickup.scheduleConfig.special.tooltipDescription") ||
      "Jadwal khusus akan menggantikan jadwal rutin pada tanggal yang dipilih."
    );
  }

  get isMaxDates(): boolean {
    return this.dates.length >= 3;
  }

  get existingDates(): string[] {
    return this.dates.map((d) => d.date);
  }

  get sortedDates(): SpecialDateSchedule[] {
    return [...this.dates].sort((a, b) => a.date.localeCompare(b.date));
  }

  onToggleEnabled(val: boolean): void {
    this.$emit("update:enabled", val);
  }

  toggleTooltip(event: Event): void {
    this.isActiveTooltip = !this.isActiveTooltip;
    const op = this.$refs.opTooltip as any;
    if (op) {
      op.toggle(event);
    }
  }

  onOpenModal(): void {
    if (this.isMaxDates || this.loading) return;
    this.modalOpen = true;
  }

  onReset(): void {
    this.$emit("update:dates", []);
    this.$emit("update:enabled", false);
  }

  onUpdateSlots(date: string, newSlots: RegularTimeSlot[]): void {
    const updated = this.dates.map((item) => {
      if (item.date === date) {
        return { ...item, slots: newSlots };
      }
      return item;
    });
    this.$emit("update:dates", updated);
  }

  onRemoveDate(date: string): void {
    const updated = this.dates.filter((item) => item.date !== date);
    this.$emit("update:dates", updated);
  }

  onModalSave(payload: SpecialDateSchedule): void {
    if (this.dates.length >= 3) {
      this.modalOpen = false;
      return;
    }

    const isDuplicate = this.dates.some((item) => item.date === payload.date);
    if (isDuplicate) {
      this.modalOpen = false;
      return;
    }

    const updated = [...this.dates, payload].sort((a, b) =>
      a.date.localeCompare(b.date)
    );

    this.$emit("update:dates", updated);
    this.modalOpen = false;
  }

  formatDateLabel(isoDate: string): string {
    if (!isoDate) return "";
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Okt",
      "Nov",
      "Des"
    ];
    const [year, month, day] = isoDate.split("-");
    const monthIndex = parseInt(month, 10) - 1;
    return `${parseInt(day, 10)} ${months[monthIndex] || ""} ${year}`;
  }
}
